import React, { useState, useRef } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    FormControl,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Auth } from 'aws-amplify';
import { host } from "../../../data";
import WiFiActivationCodeImg from '../../../OrgPage/OrgBilling/Components/Assets/WiFi_ActivationCode_ti40040.png';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
        marginBottom: 20
    },
    clickButtons: {
        marginRight: theme.spacing(2),
    },
    grow: {
        flexGrow: 1,
    },
    HubInfoImg: {
        maxHeight: '200px',
        marginRight: theme.spacing(2),
    },
}));

const AddDevice = ({ orgInfo, branchInfo, siteId, updateDevices, hasBillingInfo }) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const [deviceFamily, setDeviceFamily] = useState();
    const [deviceUID, setDeviceUID] = useState();
    const [targetUID, setTargetUID] = useState();
    const rdeviceUID = useRef();
    const [activationCode, setActivationCode] = useState();
    const ractivationCode = useRef();
    const [addDeviceDialogue, setAddDeviceDialogue] = useState(false);
    const [openEnterSerial, setOpenEnterSerial] = useState(false);

    const fetchAvailableDevices = () => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                const sessionToken = data.signInUserSession.idToken.jwtToken;
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': sessionToken
                    }
                };
                fetch(host + '/orgs/' + orgInfo.orgId + '/availabledevices', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error = "OK") {
                            updateDevices(data);
                        }
                        else {
                            alert(data.error);
                        }
                    }).catch((error) => {
                    });
            })
    };

    const handleOpenAddDevice = () => {
        if (deviceUID) {
            var tDeviceUID = deviceUID.replace(/\b0+/g, "");
        }
        else {
            var tDeviceUID = "";
        }

        if (tDeviceUID !== "") {
            handleCloseEnterSerial();
            Auth.currentAuthenticatedUser()
                .then(data => {
                    var body = JSON.stringify({ 'UID': tDeviceUID });
                    var requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body,
                    };

                    fetch(host + '/device', requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            if (data.error === "OK") {

                                if (data.isAvailable === 1) {
                                    setDeviceFamily(data.family);
                                    setAddDeviceDialogue(true);
                                    if (data.family === "WiFi") {
                                        setTargetUID(Number(data.UID).toString());
                                    } else {
                                        setTargetUID(data.UID.toUpperCase());
                                    }
                                }
                                else {
                                    alert(t("deviceIsAlreadyAssigned"));
                                }
                            }
                            else {
                                alert(data.error);
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                });
        }
        else {
            setOpenEnterSerial(true);
        }
    };

    const handleCloseAddDevice = () => {
        setAddDeviceDialogue(false);
    };
    const handleOpenEnterSerial = () => {
        setOpenEnterSerial(true);
    };
    const handleCloseEnterSerial = () => {
        setOpenEnterSerial(false);
        setDeviceUID("");
    };

    const handleAddDevice = () => {
        var code = activationCode;
        if (deviceFamily === "PulseHUB") {
            code = "";
        }

        if (deviceFamily === "cellular" || deviceFamily === 'pressure') {
            code = "";
        }
        var l_hasBillingInfo = hasBillingInfo ? 1 : 0;

        setAddDeviceDialogue(false);
        Auth.currentAuthenticatedUser()
            .then(data => {
                var body = JSON.stringify({
                    'devices': [{ 'uid': targetUID, 'code': code, 'action': "add" }],
                    'hasBillingInfo': l_hasBillingInfo, 'sync': 0
                });
                var requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                    body: body
                };
                console.log(body);

                let url = host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/device/';

                fetch(url, requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error === "OK") {
                            setDeviceUID("");
                            setActivationCode("");
                            fetchAvailableDevices();
                        }
                        else {
                            if (data.error === "error" && data.errorList.length > 0) {
                                console.log(data.errorList);
                                alert(data.errorList[0].error);
                            }
                            else {
                                console.log(data.error);
                                alert(data.error)
                            }
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
            });
    };

    return (
        <>
            {orgInfo.isOrgEditor === true && <Button
                onClick={handleOpenEnterSerial}
                variant='contained'
                color='secondary'>
                {t("addDevice")}
            </Button>}
            {openEnterSerial && <Dialog disableBackdropClick disableEscapeKeyDown open={openEnterSerial} onClose={handleCloseEnterSerial}>
                <DialogTitle>{t("enterSerialNumber")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <FormControl className={classes.formControl}>
                        <TextField type="test" label={t("serialNumber")}
                            inputRef={rdeviceUID}
                            value={deviceUID}
                            onChange={(e) => {
                                const regex = /^([ a-zA-Z0-9]){0,30}$/i;
                                if (regex.test(e.target.value)) {
                                    setDeviceUID(e.target.value.toUpperCase());
                                }
                            }
                            }
                            helperText={t("tankLevelMonitor")} />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEnterSerial} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button variant="contained" onClick={handleOpenAddDevice} color="primary" disabled={!deviceUID}>
                        {t("add")}
                    </Button>
                </DialogActions>
            </Dialog>}
            {addDeviceDialogue && <Dialog disableBackdropClick disableEscapeKeyDown open={addDeviceDialogue} onClose={handleCloseAddDevice}>
                <DialogTitle>{t("addDevice")}</DialogTitle>
                <DialogContent className={classes.root}>
                    <Grid item container>
                        {deviceFamily === "WiFi" && <Grid item>
                            <Typography variant="body2">
                                {t("add")} {deviceFamily + " device "} {targetUID}?
                            </Typography>
                            {<img edge='start'
                                alt='Wi-Fi Activation Code'
                                className={classes.HubInfoImg}
                                src={WiFiActivationCodeImg} />}
                            <Typography variant="body2">
                                {t("activationCodeCanBeFound")}
                            </Typography>
                            <FormControl className={classes.formControl}>
                                <TextField label="Activation Code"
                                    inputRef={ractivationCode}
                                    value={activationCode}
                                    onChange={e => setActivationCode(e.target.value.toUpperCase())} />
                            </FormControl>
                        </Grid>}
                        {(deviceFamily === "cellular" || deviceFamily === "pressure") && hasBillingInfo ? <Grid item>
                            <Typography gutterBottom variant="body2">
                                {t("add")} {deviceFamily + " device "} {targetUID}?
                            </Typography>
                            <div />
                            <Typography variant="body2">
                                {t("noteThisDeviceWillNotTake")}
                            </Typography>
                        </Grid>
                            : <Grid>
                                {(deviceFamily === "cellular" || deviceFamily === "pressure") && <Typography variant="body2" colorError gutterBottom>
                                    {t("priorToAddingThisDeviceBilling")}
                                </Typography>}
                            </Grid>}
                        {deviceFamily === "PulseHUB" && <Grid item>
                            <Typography gutterBottom variant="body2">
                                {t("addPulseProTlm")}{" " + targetUID}?
                            </Typography>
                        </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddDevice} color="primary">
                        {t("cancel")}
                    </Button>
                    <Button disabled={(deviceFamily === "cellular" || deviceFamily === "pressure") && !hasBillingInfo}
                        variant="contained" onClick={handleAddDevice} color="primary">
                        {t("add")}
                    </Button>
                </DialogActions>
            </Dialog>}
        </>
    );
}

export default AddDevice;